
import AnimatedSection from '../components/AnimatedSection';
// --- Contact Section ---
const Contact = ({ onContactClick }) => (
    <AnimatedSection id="contact" className="py-24 text-center">
        <h2 className="text-4xl font-bold text-white mb-4">Have a Project in Mind?</h2>
        <p className="text-slate-400 mb-8 max-w-xl mx-auto text-lg">
            Let's build something great together. I'm currently available for freelance projects and full-time opportunities.
        </p>
        <button
            onClick={onContactClick}
            className="inline-block bg-cyan-500 text-white font-bold text-lg py-4 px-8 rounded-lg hover:bg-cyan-600 transition-all duration-300 shadow-lg shadow-cyan-500/30"
        >
            Get In Touch
        </button>
    </AnimatedSection>
);

export default Contact;